import { NgModule } from '@angular/core';
import { ServicesService } from './services.service';
import { UsersService } from './users.service';
import { UsersServiceV2 } from './users-v2.service';
import { WorkspacesService } from './workspaces.service';

@NgModule({
  providers: [WorkspacesService, ServicesService, UsersService, UsersServiceV2],
})
export class ServicesModule {}
